import { useRouter } from 'next/router';
// @mui
import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
// components
import Iconify from '../../components/Iconify';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import { PATH_DASHBOARD } from '../../routes/paths';

export default function OfferClosingDialog({ isOpen }) {
  const router = useRouter();
  const smUp = useResponsive('up', 'sm');

  const moveToDashboard = async () => {
    router.push(PATH_DASHBOARD.crew);
  }

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} paragraph>
          해당 공고는 마감되었습니다. <br />
          새로운 공고가 등록되면 다시 알려드리겠습니다.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          이 공고는 제한된 숫자의 인원을 모집하는 공고로, 최대 인원이 모두 모집되어 공고를 마감하였습니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          variant="contained"
          onClick={moveToDashboard}
          size="large"
          sx={{ px: 4 }}
          fullWidth={!smUp}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  )
};
